import styled, { css } from 'styled-components';
import { Button, Row } from '@cuemath/comps';

import COLORS from 'constants/colors';

export {
  Container,
  LeftPanel,
  RightPanel,
  EmptyState,
} from '../dispositions/styled-comps';

export {
  FormContainer,
  FormHeader,
  FormTitle,
  Field,
  Label,
  Input,
  TextArea,
  ButtonRow,
  SaveButton,
  DeleteButton,
  SecondaryButtonRow,
  ModalOverlay,
  ModalBox,
  ModalTitle,
  ModalText,
  ModalActions,
  ModalCancelButton,
  ModalConfirmDeleteButton,
} from '../dispositions/styled-comps';

export const SearchInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: none;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-bottom-color: #0177ff;
  }
`;

export const ListContainer = styled.div`
  flex: 1;
  overflow-y: auto;
`;

export const ArticleItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  cursor: pointer;
  border-bottom: 1px solid #f5f5f5;
  background: ${({ $selected }) => ($selected ? '#E8F0FE' : 'transparent')};

  &:hover {
    background: ${({ $selected }) => ($selected ? '#E8F0FE' : '#f9f9f9')};
  }
`;

export const ArticleTitle = styled.div`
  flex: 1;
  font-size: 13px;
  color: #2b2b2b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

// Shared so the two stacked affordances cannot drift apart on a restyle.
const dashedAffordance = css`
  padding: 8px;
  font-size: 13px;
  font-weight: 600;
  color: ${COLORS.LINK};
  background: transparent;
  border: 1px dashed ${COLORS.LINK};
  border-radius: 4px;
`;

export const NewButton = styled(Button)`
  && {
    margin: 10px 12px;
    ${dashedAffordance}
    cursor: pointer;
    height: auto;
  }

  && > * {
    border: none;
    padding: 0;
    background: transparent;
  }
  &&:hover {
    background: #f0f7ff;
    border: 1px dashed #0177ff;
  }
`;

// An anchor, not a Button: the uploader is a Flask-Admin page on the admin
// host, not an in-app route. flex-shrink is explicit because LeftPanel is a
// column flex container whose sibling list scrolls — without it this is the
// element that gets compressed on a short viewport.
export const BulkUploadLink = styled.a`
  margin: 0 12px 10px;
  ${dashedAffordance}
  flex-shrink: 0;
  text-align: center;
  text-decoration: none;

  &:hover {
    background: #f0f7ff;
  }
`;

export const BulkUploadDisabled = styled(BulkUploadLink).attrs({ as: 'span' })`
  opacity: 0.45;
  cursor: not-allowed;
`;

// Tag chip components for scope field
export const TagInputContainer = styled(Row)`
  && {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    padding: 6px 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    min-height: 38px;
    box-sizing: border-box;
    cursor: text;
  }

  &&:focus-within {
    border-color: #0177ff;
  }
`;

export const TagChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  background: #e8f0fe;
  color: #0177ff;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;
`;

export const TagRemoveButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  border: none;
  background: transparent;
  color: #0177ff;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  border-radius: 50%;
  opacity: 0.6;

  &:hover {
    opacity: 1;
    background: rgba(1, 119, 255, 0.12);
  }
`;

export const TagTextInput = styled.input`
  flex: 1;
  min-width: 80px;
  border: none;
  outline: none;
  font-size: 14px;
  padding: 2px 0;
  background: transparent;
`;
